import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, ChevronLeft, Lock } from 'lucide-react';

const AccessDenied = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        // Simple logout logic
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login'; // Or wherever the login route is
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: '#f8f9fa',
            fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
            {/* Logo at the top */}
            <div style={{ marginBottom: '20px' }}>
                <img 
                    src="https://docs.kit19.com/assets/custom/partner/resource/10043/logobig.PNG" 
                    alt="Kit19 Logo" 
                    style={{ height: '60px', objectFit: 'contain' }}
                />
            </div>

            {/* Access Denied Box */}
            <div style={{
                backgroundColor: '#ffffff',
                border: '1px dashed #d1d5db',
                borderRadius: '8px',
                padding: '40px',
                width: '100%',
                maxWidth: '600px',
                textAlign: 'center',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
            }}>
                {/* Icon */}
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                    <div style={{ position: 'relative' }}>
                        <svg width="100" height="80" viewBox="0 0 100 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="15" y="30" width="70" height="40" rx="4" fill="#e5e7eb" stroke="#9ca3af" strokeWidth="3"/>
                            <rect x="35" y="10" width="30" height="20" rx="10" fill="none" stroke="#9ca3af" strokeWidth="4"/>
                            <path d="M45 45v10m10-10v10" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round"/>
                            <rect x="10" y="70" width="80" height="5" rx="2" fill="#9ca3af"/>
                            <Lock color="#4b5563" size={32} style={{ position: 'absolute', top: '34px', left: '34px' }} />
                        </svg>
                    </div>
                </div>

                {/* Text Content */}
                <h2 style={{ 
                    color: '#4b5563', 
                    fontSize: '22px', 
                    fontWeight: '600', 
                    marginBottom: '16px' 
                }}>
                    Access Denied/Forbidden
                </h2>
                
                <p style={{ 
                    color: '#6b7280', 
                    fontSize: '16px', 
                    marginBottom: '40px',
                    lineHeight: '1.5'
                }}>
                    The Page or resource you were trying to reach is not authorised to access
                </p>

                {/* Bottom Actions */}
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    borderTop: '1px dashed #e5e7eb',
                    paddingTop: '20px',
                    marginTop: '20px'
                }}>
                    <button 
                        onClick={() => navigate('/')}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            background: 'none',
                            border: 'none',
                            color: '#0284c7',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f9ff'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <ChevronLeft size={16} style={{ marginRight: '4px' }} />
                        Back to Dashboard
                    </button>

                    <button 
                        onClick={handleLogout}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            background: 'none',
                            border: 'none',
                            color: '#0284c7',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f9ff'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <LogOut size={16} style={{ marginRight: '6px' }} />
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AccessDenied;
